import requestFunctions from "../../functions/requestFunctions";


export const state = {
    CALLS_ITEM: {},

    CALLS_LIST: [],
    CALLS_TABLE_DATA: [],
    CALLS_TOTAL_ROWS: 0
}

export const getters = {
    GET_CALLS_ITEM: (state) => {
        return state.CALLS_ITEM;
    },
    GET_CALLS_LIST: (state) => {
        return state.CALLS_LIST;
    },
    GET_CALLS_TABLE_DATA: (state) => {
        return state.CALLS_TABLE_DATA;
    },
    GET_CALLS_TOTAL_ROWS: (state) => {
        return state.CALLS_TOTAL_ROWS;
    }
}

export const mutations = {

    UPDATE_CALLS_ITEM(state, item) {
        state.CALLS_ITEM = item;
    },

    UPDATE_CALLS_LIST(state, list) {

        state.CALLS_LIST = list.data;
        state.CALLS_TABLE_DATA = [];

        state.CALLS_TOTAL_ROWS = list.total;
        list = list.data;

        if(list.length > 0) {
            list.forEach(el => {

                let status = {
                    'created': 'Создан',
                    'queued': 'В очереди', 
                    'in_progress': 'Активный звонок',
                    'ringing': 'Активный вызов',
                    'busy': 'Занято',
                    'answer': 'Отвечено',
                    'noanswer': 'Нет ответа',
                    'cancel': 'Сброс',
                    'congestion': 'Недоступен',
                    'chanunavail': 'Канал недоступен',
                    'error': 'Ошибка',
                    'delayed': 'Отложенный',
                    'planned': 'Запланирован',
                    'blocked': 'Заблокирован',
                    'retry': 'Перезвонить',
                    'stopped': 'Остановлен',
                    'canceled': 'Отменен',
                    'voicemail': 'Автоответчик',
                    '': '-'
                };

                let contact_fullname = el.contact_fullname ? el.contact_fullname : '';
                let contact_phone = el.contact_phone ? el.contact_phone : '';
                
                if (contact_fullname === ''){
                    if(el.variables){
                        let contact_data = JSON.parse(el.variables);                        
                        if(contact_data && contact_data.last_name){                            
                            contact_fullname += contact_data.last_name;                            
                        }
                        if(contact_data && contact_data.first_name){
                            if(contact_fullname.length > 0) contact_fullname += ' ';
                            contact_fullname += contact_data.first_name;
                        }
                        if(contact_data && contact_data.middle_name){
                            if(contact_fullname.length > 0) contact_fullname += ' ';
                            contact_fullname += contact_data.middle_name;
                        }
                    }
                }

                if (contact_phone === '' && el.c_phone){
                    contact_phone = el.c_phone;
                }   

                let cost = el.cost ? el.cost  + ' руб.' : '0 руб.';

                if(el.bill_sec === 'null' || el.bill_sec === null){
                    el.bill_sec = 0;
                }

                let call_type = '';

                if(el.call_type === 'out'){
                    call_type = 'Исходящий';
                }

                if(el.call_type === 'in'){
                    call_type = 'Входящий';
                }

                let caller_number = el.caller_number ? el.caller_number : 'динамический';

                if(caller_number === 'outer'){
                    caller_number = "внешний";
                }

                state.CALLS_TABLE_DATA.push({
                    'id'               : el.id,
                    'uuid'             : el.uuid,
                    'created_at'       : el.created_at,
                    'contact_fullname' : contact_fullname,
                    'contact_phone'    : contact_phone,
                    'call_type'        : call_type, 
                    'bot_name'         : el.bot_name ? el.bot_name : '',
                    'bot_uuid'         : el.bot_uuid ? el.bot_uuid : '',
                    'skill_name'       : el.skill_name ? el.skill_name : '',
                    'account_number'   : el.account_number ? el.account_number : '',
                    'bill_sec'         : el.bill_sec + ' сек',
                    'tariff_name'      : el.tariff_name,
                    'cost'             : cost,
                    'caller_number'    : caller_number,
                    'trunk_name'       : el.trunk_name ? el.trunk_name : 'по умолчанию',
                    'variables'        : el.variables ? JSON.parse(el.variables) : null,
                    'retries'          : el.attempt + ' / ' + el.attempts,
                    'updated_at'       : el.updated_at,
                    'delayed_at'       : el.delayed_at,
                    'is_archive'       : el.is_archive,
                    'pbx_server_name'  : el.pbx_server_name,
                    'demons_server_name' : el.demons_server_name,
                    'storage'          : el.storage,
                    'status'           : status[el.status] ? status[el.status] : '',
                });

            });
        }
    },
}


export const actions = {

    async FETCH_CALLS_ITEM({ commit }, payload) {

        let query_url = 'https://api.client.za-bota.com/v1/calls/'+payload.uuid;

        let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

        if(response.status !== 'success'){
            return false;
        } else {
            commit('UPDATE_CALLS_ITEM', response.data);
            return response.data;
        }
    },

    async FETCH_CALLS_LIST({ commit }, payload= {}) {

        let query_url = 'https://api.client.za-bota.com/v1/calls';

        let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

        if(response.status !== 'success'){
            return false;
        } else {
            commit('UPDATE_CALLS_LIST', response.data);
            return response.data;
        }
    },

    async FETCH_CALLS_CREATE({ commit }, payload) {

        let query_url = 'https://api.client.za-bota.com/v1/calls';
        
        payload.priority = 100;
        let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

        if(response.status !== 'success'){
            return false;
        } else {
            return response.data;
        }
    },

    async FETCH_CALLS_UPDATE({ commit }, payload) {

        let query_url = 'https://api.client.za-bota.com/v1/calls/'+payload.uuid;

        let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

        if(response.status !== 'success'){
            return false;
        } else {
            return response.data;
        }
    },

    async FETCH_CALLS_DELETE({ commit }, payload) {

        let query_url = 'https://api.client.za-bota.com/v1/calls/'+payload.uuid;

        let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

        if(response.status !== 'success'){
            return false;
        } else {
            return response.data;
        }
    },
}